import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../../services/api.service'
import { ButtonComponent } from '@components/button/button.component'
import { CommonModule } from '@angular/common'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { HomeLinksService } from '../../../services/home-links.service'

export interface CtaCard {
    title: string
    link?: string
    action?: () => void
    hoverImage: string
    buttonText: string
    svgIcon: string
    disabled?: boolean
}
@Component({
    selector: 'app-cta-block',
    templateUrl: './cta-block.component.html',
    imports: [ButtonComponent, CommonModule, TranslateModule, CosentinoSvgComponent],
    standalone: true,
    // styleUrl: './home.component.scss',
})
export class CtaBlock implements OnInit {
    userInfo: UserInfo
    ctaCards: CtaCard[] = []
    hoveredCard: any = null

    constructor(
        private api: ApiService,
        private translate: TranslateService,
        private homeLinksService: HomeLinksService,
    ) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo

            const role = userInfo.accountType as keyof ReturnType<typeof this.buildCtas>
            console.log(role)
            console.log(userInfo.accountType, 'accounttype')
            const CTAS = this.buildCtas() // ← construimos con this ya disponible
            let cards = CTAS[role] || []
            // Business rule: CLAIMS ("my-claims") must only be visible to accounts with the
            // canAccessClaims authority (granted only when the account has a SAP customer id).
            if (!userInfo.authorities?.includes('canAccessClaims')) {
                cards = cards.filter((card) => card.svgIcon !== 'claims')
            }
            this.ctaCards = cards
        })
    }
    private buildCtas() {
        let claimsNode = {
            title: this.translate.instant('my_claims.create_new_claim'),
            action: () => this.homeLinksService.goToClaims(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Claim.png',
            buttonText: this.translate.instant('home.register'),
            svgIcon: 'claims',
        }
        let samplesNode = {
            title: this.translate.instant('home.request_samples_for_your_proyects'),
            action: () => this.homeLinksService.goToSamples(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Muestras.png',
            buttonText: this.translate.instant('order_samples.request_samples'),
            svgIcon: 'samples',
        }

        let visualizersNode = {
            title: this.translate.instant('home.combine_materials_with_the_3d_visualizer'),
            action: () => this.homeLinksService.goToVisualizers(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Visualizador.png',
            buttonText: this.translate.instant('home.start'),
            svgIcon: 'visualizers',
        }
        let inspirationNode = {
            title: this.translate.instant('home.discover_the_latest_projects_and_interviews'),
            action: () => this.homeLinksService.goToInspiration(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Inspirate.png',
            buttonText: this.translate.instant('home.access'),
            svgIcon: 'inspiration',
        }
        let showroomAppointmentNode = {
            title: this.translate.instant('menu.DESIGNER.showroom-appointment'),
            action: () => this.homeLinksService.goToShowroomAppointment(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/City.png',
            buttonText: this.translate.instant('home.book'),
            svgIcon: 'visit',
        }
        let displaysNode = {
            title: this.translate.instant('home.new-display-request'),
            action: () => this.homeLinksService.goToDisplays(),
            hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/displays.png',
            buttonText: this.translate.instant('home.request'),
            svgIcon: 'exposicion',
        }
        return {
            FABRICATOR: [
                claimsNode,
                {
                    title: this.translate.instant('home.access_your_financial_portal'),
                    action: () => this.homeLinksService.goToFinancialPortal(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/PortalFinanciero.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'actios',
                    disabled: this.userInfo.mainMenu.items.find((item) => item.code === 'my-financial-portal') ? false : true,
                },
                {
                    title: this.translate.instant('home.upload_your_rates'),
                    action: () => this.homeLinksService.goToMyRates(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Tarificador.png',
                    buttonText: this.translate.instant('home.upload'),
                    svgIcon: 'tarificador',
                },
                {
                    title: this.translate.instant('home.view_our_technical_documents'),
                    action: () => this.homeLinksService.goToTechnicalDocumentation(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/docTecnica.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'documents',
                },
                displaysNode // como solo pinta 4, solo se pinta si el usuario no tiene financial portal
            ],
            INSTALLER: [claimsNode, samplesNode, displaysNode],
            RETAIL: [
                {
                    title: this.translate.instant('my_sales.mysales_registersale_title'),
                    action: () => this.homeLinksService.goToSales(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Sales.png',
                    buttonText: this.translate.instant('home.register'),
                    svgIcon: 'tarificador',
                },
                displaysNode,
                {
                    title: this.translate.instant('my-galleries.button-add-new-gallery'),
                    action: () => this.homeLinksService.goToGalleries(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Galeria.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'galeries',
                },
                samplesNode,
            ],
            ARCHITECT: [
                visualizersNode,
                inspirationNode,
                {
                    title: this.translate.instant('home.find_technical_information'),
                    action: () => this.homeLinksService.goToTechnicalDocumentation(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/docTecnica.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'document',
                },
                showroomAppointmentNode,
            ],
            DESIGNER: [
                {
                    title: this.translate.instant('home.check_your_designer_rate'),
                    action: () => this.homeLinksService.goToDesignerRate(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/TarifaDisenadores.png',
                    buttonText: this.translate.instant('home.download'),
                    svgIcon: 'actios',
                },
                visualizersNode,
                inspirationNode,
                showroomAppointmentNode,
            ],
            DISTRIBUTOR: [
                claimsNode,
                {
                    title: this.translate.instant('home.access_your_financial_portal'),
                    action: () => this.homeLinksService.goToFinancialPortal(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/PortalFinanciero.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'actios',
                    disabled: this.userInfo.mainMenu.items.find((item) => item.code === 'my-financial-portal') ? false : true,
                },
                {
                    title: this.translate.instant('home.upload_your_rates'),
                    action: () => this.homeLinksService.goToMyRates(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/Tarificador.png',
                    buttonText: this.translate.instant('home.upload'),
                    svgIcon: 'tarificador',
                },
                {
                    title: this.translate.instant('home.view_our_technical_documents'),
                    action: () => this.homeLinksService.goToTechnicalDocumentation(),
                    hoverImage: 'https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/homeServices/docTecnica.png',
                    buttonText: this.translate.instant('home.access'),
                    svgIcon: 'documents',
                },
                displaysNode
            ],
        }
    }
}
